// extracted by mini-css-extract-plugin
export var ampersand = "bfcmHero-module--ampersand--f0781";
export var arrow = "bfcmHero-module--arrow--5c89b";
export var arrowContent = "bfcmHero-module--arrowContent--cefd2";
export var audienceContent = "bfcmHero-module--audienceContent--77b2f";
export var bfcmHero = "bfcmHero-module--bfcmHero--96aa1";
export var container = "bfcmHero-module--container--319d7";
export var eyebrow = "bfcmHero-module--eyebrow--7ccca";
export var goalSelector = "bfcmHero-module--goalSelector--d25ad";
export var headline = "bfcmHero-module--headline--6e015";
export var headlineFilterText = "bfcmHero-module--headlineFilterText--b8e56";
export var selectorContent = "bfcmHero-module--selectorContent--8cd15";
export var textContent = "bfcmHero-module--textContent--3c6d3";